import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.367 28.82a1 1 0 0 1-.398-.626q-.065-.387.141-.962l2.739-8.003-7.058-4.951q-.501-.337-.681-.688a.96.96 0 0 1-.065-.737.97.97 0 0 1 .489-.55q.36-.188.99-.176l8.664.038 2.636-8.04q.206-.575.488-.85A.97.97 0 0 1 15.994 3q.398 0 .694.275t.488.85l2.636 8.04 8.677-.037q.617-.013.977.175.36.186.489.55a.96.96 0 0 1-.065.737q-.18.35-.68.688l-7.059 4.951 2.752 8.003q.192.575.115.962a.94.94 0 0 1-.386.626.9.9 0 0 1-.732.162q-.4-.063-.887-.4l-7.02-5.001-7.006 5q-.487.34-.9.401a.89.89 0 0 1-.72-.162"
    }, null, -1)
  ]))]))
}
export default { render: render }